var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabBox"},[_c('div',{staticClass:"left"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"right"},[_c('span',{staticClass:"Breadcrumb",on:{"click":_vm.goHome}},[_vm._v(_vm._s(_vm.$t('message.tabs.home')))]),_c('span',[_vm._v(" > "+_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }